import { Hub, Sell } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import {
  FilterAccordionContainer,
  FilterCollapsibleList,
  FilterContainer,
  FilterFooter,
  FilterHeader,
} from '~/components/Filter';
import type { ContentFolderView__FilterCount } from '../ContentFolderView.generated';
import type { ContentFilterArgs, ContentFilters } from '../lib';

export interface ContentFilterAccordionProps {
  clearFilter: () => void;
  filters: ContentFilters;
  filterCounts: ContentFolderView__FilterCount | undefined;
  toggleAccordion: (field: keyof ContentFilters) => void;
  updateFilter: (args: ContentFilterArgs) => void;
}

export const ContentFilterAccordion = ({
  clearFilter,
  filters,
  filterCounts,
  toggleAccordion,
  updateFilter,
}: ContentFilterAccordionProps) => {
  const { t } = useTranslation();

  return (
    <FilterContainer>
      <FilterHeader />
      <FilterAccordionContainer>
        {filters.tags.items.length > 0 && (
          <FilterCollapsibleList
            Icon={Sell}
            expanded={filters.tags.open}
            items={filters.tags.items.map((item) => {
              const matched = filterCounts?.tags.find((c) => c.filter === item.value);
              return { ...item, count: matched?.count || 0 };
            })}
            label={t('common.labels.tags')}
            loading={!filterCounts}
            onClick={(_, items) => updateFilter({ field: 'tags', items })}
            onExpand={() => toggleAccordion('tags')}
          />
        )}
        {filters.kind.items.length > 0 && (
          <FilterCollapsibleList
            Icon={Hub}
            expanded={filters.kind.open}
            items={filters.kind.items.map((item) => {
              const matched = filterCounts?.kind.find(
                (c) => c.filter.toLowerCase() === item.value.toLowerCase(),
              );
              return { ...item, count: matched?.count || 0 };
            })}
            label={t('pages.content.filters.kind')}
            loading={!filterCounts}
            onClick={(_, items) => updateFilter({ field: 'kind', items })}
            onExpand={() => toggleAccordion('kind')}
          />
        )}
      </FilterAccordionContainer>
      <FilterFooter handleClear={clearFilter} />
    </FilterContainer>
  );
};
